import React from "react";
import { useNavigate } from "react-router-dom";

const ISSUE_LABELS = {
  NO_USER_TYPE: { label: "No Access Classification", color: "#e67e22", bg: "#fef3e2" },
  NO_SUBSCRIPTION: { label: "No Subscription", color: "#c0392b", bg: "#fde8e8" },
};

const PendingUsersModal = ({ users = [], onClose }) => {
  const navigate = useNavigate();

  if (!users.length) return null;

  const handleAssign = (user) => {
    onClose();
    // Navigate to the user edit page
    navigate(`/users/update`, { state: { userId: user.id } });
  };

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          zIndex: 1050,
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1051,
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          width: "min(96vw, 640px)",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "20px 24px 16px",
            borderBottom: "1px solid #eee",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div>
            <h5 style={{ margin: 0, fontWeight: 700, color: "#1a1a2e" }}>
              Users Requiring Setup
            </h5>
            <p style={{ margin: "4px 0 0", fontSize: 13, color: "#666" }}>
              {users.length} user{users.length !== 1 ? "s" : ""} need attention
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: 22,
              cursor: "pointer",
              color: "#888",
              lineHeight: 1,
            }}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        {/* User list */}
        <div style={{ overflowY: "auto", flex: 1, padding: "12px 24px" }}>
          {users.map((user) => {
            const issue = ISSUE_LABELS[user.issue] || { label: user.issue, color: "#555", bg: "#f5f5f5" };
            return (
              <div
                key={`${user.id}-${user.issue}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "12px 0",
                  borderBottom: "1px solid #f2f2f2",
                  gap: 12,
                }}
              >
                {/* User info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ margin: 0, fontWeight: 600, fontSize: 14, color: "#222", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                    {user.userName || user.emailId || user.mobileNo}
                  </p>
                  <p style={{ margin: "2px 0 0", fontSize: 12, color: "#888" }}>
                    {user.mobileNo}
                  </p>
                </div>

                {/* Issue badge */}
                <span
                  style={{
                    fontSize: 11,
                    fontWeight: 600,
                    padding: "3px 10px",
                    borderRadius: 20,
                    background: issue.bg,
                    color: issue.color,
                    whiteSpace: "nowrap",
                    flexShrink: 0,
                  }}
                >
                  {issue.label}
                </span>

                {/* 7.7 — Assign button */}
                <button
                  onClick={() => handleAssign(user)}
                  style={{
                    background: "#4a6fa5",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "6px 14px",
                    fontSize: 12,
                    fontWeight: 600,
                    cursor: "pointer",
                    flexShrink: 0,
                    whiteSpace: "nowrap",
                  }}
                >
                  Assign
                </button>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div
          style={{
            padding: "14px 24px",
            borderTop: "1px solid #eee",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            onClick={onClose}
            style={{
              background: "#f0f0f0",
              border: "none",
              borderRadius: 6,
              padding: "8px 20px",
              fontSize: 13,
              fontWeight: 600,
              cursor: "pointer",
              color: "#444",
            }}
          >
            Dismiss
          </button>
        </div>
      </div>
    </>
  );
};

export default PendingUsersModal;
